export default __webpack_public_path__ + "static/media/background_waves_red.be9c54c2.jpg";